var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeapDeactiveicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62455 10.3333C6.56503 10.1026 6.44477 9.89206 6.27629 9.72358C6.10781 9.5551 5.89726 9.43485 5.66655 9.37533L1.57655 8.32066C1.50677 8.30085 1.44535 8.25883 1.40162 8.20096C1.35789 8.14309 1.33423 8.07253 1.33423 7.99999C1.33423 7.92746 1.35789 7.8569 1.40162 7.79903C1.44535 7.74116 1.50677 7.69913 1.57655 7.67933L5.66655 6.62399C5.89718 6.56453 6.10767 6.44438 6.27615 6.27602C6.44462 6.10766 6.56492 5.89725 6.62455 5.66666L7.67921 1.57666C7.69882 1.50661 7.7408 1.44489 7.79876 1.40092C7.85672 1.35696 7.92747 1.33316 8.00021 1.33316C8.07296 1.33316 8.14371 1.35696 8.20166 1.40092C8.25962 1.44489 8.30161 1.50661 8.32121 1.57666L9.37521 5.66666C9.43473 5.89737 9.55499 6.10792 9.72347 6.27641C9.89195 6.44489 10.1025 6.56514 10.3332 6.62466L14.4232 7.67866C14.4935 7.69806 14.5556 7.74 14.5998 7.79804C14.644 7.85609 14.6679 7.92703 14.6679 7.99999C14.6679 8.07295 14.644 8.1439 14.5998 8.20194C14.5556 8.25999 14.4935 8.30193 14.4232 8.32133L10.3332 9.37533C10.1025 9.43485 9.89195 9.5551 9.72347 9.72358C9.55499 9.89206 9.43473 10.1026 9.37521 10.3333L8.32055 14.4233C8.30094 14.4934 8.25896 14.5551 8.201 14.5991C8.14304 14.643 8.07229 14.6668 7.99955 14.6668C7.9268 14.6668 7.85605 14.643 7.79809 14.5991C7.74013 14.5551 7.69815 14.4934 7.67855 14.4233L6.62455 10.3333Z",
    stroke: "#334155",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2V4.66667",
    stroke: "#334155",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 3.33334H12",
    stroke: "#334155",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 11.3333V12.6667",
    stroke: "#334155",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 12H2",
    stroke: "#334155",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeapDeactiveicon);
export default __webpack_public_path__ + "static/media/leap-deactiveicon.8ab748b210d37df5b5ef8a3e356030c4.svg";
export { ForwardRef as ReactComponent };